import { render, staticRenderFns } from "./WorkflowTemplateView.vue?vue&type=template&id=6d52af5a&scoped=true"
import script from "./WorkflowTemplateView.vue?vue&type=script&lang=ts"
export * from "./WorkflowTemplateView.vue?vue&type=script&lang=ts"
import style0 from "./WorkflowTemplateView.vue?vue&type=style&index=0&id=6d52af5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d52af5a",
  null
  
)

export default component.exports